const AppConstants = {
  install(vue) {
    vue.prototype.$loginRequest = {
      account: null,
      scopes: ["openid", "profile", "User.Read"]
    };
    vue.prototype.$graphConfig = {
      graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
      graphGroupsEndpoint: "https://graph.microsoft.com/v1.0/me/memberOf",
      graphMailEndpoint: "https://graph.microsoft.com/v1.0/me/messages"
    };
    vue.prototype.$tokenRequest = {
      account: null,
      scopes: ["api://68447925-3cd3-486f-8683-99a2c509ee86/full.access"],
      forceRefresh: false
    };
  }
};
export default AppConstants;
